module.exports = __webpack_public_path__ + "static/open-prs2-efc51eb8aecdea8a55ad780f275e4db7.png";